<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import { Marked } from 'marked'
import sanitizeHtml from 'sanitize-html'
import { computed } from 'vue'

const markdown = new Marked({ breaks: true })

const { text } = defineProps<{ text: string }>()

const html = computed(() => sanitizeHtml(markdown.parse(text, { async: false })))
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-html="html"></div>
</template>
